// GENERATED by movorra-flows/templates/krapf/build-flow.py — do not edit by hand.
// Field metadata for the Krapf charter intake flow, in DECLARATION ORDER, which is also
// the order TurnResult.missingFields comes back in and therefore the order the reply
// email must number its questions. Regenerate with:
//     python3 movorra-flows/templates/krapf/build-flow.py
//
// `prompt` is the authored question text, shared with the flow so the wording cannot drift.
// A null prompt means the field is never asked (narrative capture only).
export const FLOW_ID = "krapf-charter-intake";

export const INTAKE_FIELDS = [
  {
    "key": "inquirySummary",
    "label": "the request",
    "required": false,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": null
  },
  {
    "key": "returnJourney",
    "label": "return journey",
    "required": false,
    "dataType": "choice",
    "requiredIf": null,
    "options": [
      "one-way",
      "round-trip"
    ],
    "prompt": null
  },
  {
    "key": "groupName",
    "label": "group or organization",
    "required": false,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": "Which group or organization is this charter for?"
  },
  {
    "key": "contactName",
    "label": "your name",
    "required": true,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": "Who should we list as the contact for this trip?"
  },
  {
    "key": "contactEmail",
    "label": "your email address",
    "required": true,
    "dataType": "email",
    "requiredIf": null,
    "options": null,
    "prompt": "What's the best email address for the quote?"
  },
  {
    "key": "contactPhone",
    "label": "your phone number",
    "required": true,
    "dataType": "phone",
    "requiredIf": null,
    "options": null,
    "prompt": "What's the best phone number to reach you?"
  },
  {
    "key": "passengers",
    "label": "passenger count",
    "required": true,
    "dataType": "number",
    "requiredIf": null,
    "options": null,
    "prompt": "How many passengers will be travelling, including any chaperones or staff?"
  },
  {
    "key": "pickupLocation",
    "label": "pickup location",
    "required": true,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": "Where should the coach pick everyone up?"
  },
  {
    "key": "pickupCity",
    "label": "pickup city",
    "required": true,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": "Which town or city is the pickup in?"
  },
  {
    "key": "departureDate",
    "label": "departure date",
    "required": true,
    "dataType": "date",
    "requiredIf": null,
    "options": null,
    "prompt": "What date does the trip leave?"
  },
  {
    "key": "departureTime",
    "label": "departure time",
    "required": true,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": "What time should the coach depart?"
  },
  {
    "key": "dropoffLocation",
    "label": "destination",
    "required": true,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": "Where is the group headed?"
  },
  {
    "key": "dropoffCity",
    "label": "destination city",
    "required": true,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": "Which town or city is the destination in?"
  },
  {
    "key": "returnDate",
    "label": "return date",
    "required": false,
    "dataType": "date",
    "requiredIf": {
      "attribute": "returnJourney",
      "op": "EQUALS",
      "value": "round-trip"
    },
    "options": null,
    "prompt": "What date does the group travel back?"
  },
  {
    "key": "returnTime",
    "label": "return time",
    "required": false,
    "dataType": null,
    "requiredIf": {
      "attribute": "returnJourney",
      "op": "EQUALS",
      "value": "round-trip"
    },
    "options": null,
    "prompt": "What time should the coach collect the group for the return?"
  },
  {
    "key": "arriveByTime",
    "label": "arrival deadline",
    "required": false,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": "Is there a time the group needs to be there by?"
  },
  {
    "key": "luggageEquipment",
    "label": "luggage or equipment",
    "required": false,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": "Will there be luggage or equipment needing bay space?"
  },
  {
    "key": "coachType",
    "label": "coach preference",
    "required": false,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": "Any particular kind of coach you need?"
  },
  {
    "key": "billingAccountType",
    "label": "billing type",
    "required": false,
    "dataType": "choice",
    "requiredIf": null,
    "options": [
      "tax-exempt",
      "standard",
      "unknown"
    ],
    "prompt": "How should this be billed?"
  },
  {
    "key": "billingAccount",
    "label": "billing account",
    "required": false,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": "Is there an account this should be billed to?"
  },
  {
    "key": "poNumber",
    "label": "PO number",
    "required": false,
    "dataType": null,
    "requiredIf": {
      "attribute": "billingAccountType",
      "op": "EQUALS",
      "value": "tax-exempt"
    },
    "options": null,
    "prompt": "What's the PO number for this trip?"
  },
  {
    "key": "dayOfContact",
    "label": "day-of contact",
    "required": false,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": "Who should the driver call on the day of the trip, and on what number?"
  },
  {
    "key": "specialRequests",
    "label": "special requests",
    "required": false,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": "Anything else we should build into the trip, like a meal stop or an extra pickup?"
  },
  {
    "key": "customerQuestions",
    "label": "questions from the customer",
    "required": false,
    "dataType": null,
    "requiredIf": null,
    "options": null,
    "prompt": null
  }
];

/** Field metadata by key, for O(1) lookup when composing. */
export const FIELD_BY_KEY = Object.freeze(
  INTAKE_FIELDS.reduce((acc, f) => { acc[f.key] = f; return acc; }, {}),
);
